const mongoose = require('mongoose');

const Settings = new mongoose.Schema(
    [
        {
            alias: { type: String, index: true },
            data: {}
        }
    ],
    { autoIndex: false }
);
module.exports = mongoose.models?.settings || mongoose.model('settings', Settings);
